import { z } from 'zod';
import { useGenericForm } from '@/hooks/use-generic-form';
import { checkEmailSchema } from '@/validation/check-email.schema';
import { AxiosError } from 'axios';
import { useForgotPassword } from '@/api/auth/auth.hooks.ts';
import { MessageResponse } from '@/api/auth/auth.types.ts';

type RequestPasswordResetFormData = z.infer<typeof checkEmailSchema>;

export const useRequestPasswordResetForm = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (response: MessageResponse) => void;
  onError?: (error: AxiosError) => void;
}) => {
  const forgotPasswordMutation = useForgotPassword();

  return useGenericForm<RequestPasswordResetFormData, MessageResponse>({
    schema: checkEmailSchema,
    mutation: forgotPasswordMutation,
    onSuccess,
    onError,
  });
};
